import { css, styled } from 'styled-components';
import { ScMessageContainer } from '@/components/Message/styled';
import { hexToRGB, screen, typography } from '@/styles/helpers';

const PREMIUM_TITLE_GRADIENT = `linear-gradient(
  143deg,
  #d09f12 0%,
  #f0c542 42.6%,
  #f1c641 60%,
  #d09f12 100%
)`;

export const ScExchangeModal = styled.div<{ $isPremium: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  max-width: 640px;
  margin-inline: auto;
  padding: 16px 8px;

  @media (${screen.md}) {
    padding: 16px;
  }
  border-radius: 24px;
  background-color: ${({ theme }) => theme.grayDarkColor};

  & .modal-head {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: space-between;
    min-height: 40px;
  }

  & .modal-title {
    color: ${({ theme }) => theme.whiteColor};
    ${typography.body1regular}
  }

  ${ScMessageContainer} {
    padding: 16px;

    & .message {
      color: ${({ theme }) => theme.whiteColor};
    }
  }

  & .modal-body {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-inline: 4px;

    @media (${screen.md}) {
      padding-inline: 16px;
    }
  }

  & .product {
    display: flex;
    gap: 16px;
    align-items: center;
    padding-block: 8px;

    @media (${screen.md}) {
      padding-inline: 16px;
    }
  }

  & .product-label {
    align-self: flex-start;
    flex-shrink: 0;
  }

  & .product-info {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  & .product-type {
    color: ${({ theme }) => theme.amberGold};
    ${typography.body2regular}
  }

  & .product-title {
    color: ${({ theme }) => theme.secondaryColor};
    ${typography.headline2mobile}

    @media (${screen.md}) {
      font-size: 28px;
      line-height: 36px;
    }
  }

  ${({ $isPremium }) =>
    $isPremium &&
    css`
      & .product-title {
        background-image: ${PREMIUM_TITLE_GRADIENT};
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
      }
    `}
`;

export const ScExchangeModalRows = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.blackColor};

  & .row {
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
    padding-block: 8px;

    & + .row {
      border-top: 1px solid ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
    }
  }

  & .row-label {
    color: ${({ theme }) => theme.blackLightColor};
    ${typography.body2regular}
  }

  & .row-value {
    color: ${({ theme }) => theme.whiteColor};
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.14px;
    text-align: right;
  }

  & .row.accent {
    & .row-label,
    & .row-value {
      font-weight: 700;
    }
  }

  & .row-value.success {
    color: ${({ theme }) => theme.greenColor};
    font-weight: 700;
  }
`;

export const ScExchangeModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;

  & .actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;

    @media (min-width: 351px) {
      flex-direction: row;

      & > * {
        flex: 1;
      }
    }
  }

  & .terms {
    color: ${({ theme }) => theme.blackLightColor};
    ${typography.caption1regular}
    text-align: center;

    & button {
      padding: 0;
      background: none;
      color: ${({ theme }) => theme.blackLightColor};
      font: inherit;
      font-weight: 700;
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;
